<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(`apartment.tenantInfo.title`) }}</h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-sm-12">
            <b>{{ this.getFullNameByLanguage(null) }}</b> <br />
            <br />
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <!-- <b>{{ $t("customer.username") }}:</b> {{tenant.resident.username}} <br /> -->
                <b>{{ $t("customer.fullname") }}:</b> {{ this.getFullNameByLanguage(null) }} <br />
                <b>{{ $t("customer.email") }}:</b> {{tenant.resident.email}} <br />
                <b>{{ $t("customer.phone") }}:</b> {{tenant.resident.phone}} <br />
                <b>{{ $t("customer.gender") }}:</b> {{ $t(tenant.resident.gender) }} <br />
                <b>{{ $t("customer.dob") }}:</b> {{ day_of_birth }} <br />
                <b>{{ $t("customer.country") }}:</b> {{ tenant.resident.country_name }}
              </div>
              <div class="col-md-6 col-lg-6">
                <b>{{ $t("apartment.move_in") }}:</b> {{ day_move_in }} <br />
                <b>{{ $t("apartment.move_out") }}:</b> {{ day_move_out }} <br />
                <b>{{ $t("customer.current_debt") }}:</b> {{ formatNumber(current_debt) }} vnđ
              </div>
            </div>
            <br>
            <div class="row" style="margin-top: 15px">
              <button
                v-if="isTenantApartment"
                class="btn btn-primary pull-right"
                @click="onOpenAddRelative"
              >
                <i class="fa fa-plus"></i>
                {{ $t("apartment.addApartmentMember") }}
              </button>
              <button
                v-if="isTenantApartment"
                class="btn btn-danger pull-right"
                style="margin-right: 5px;"
                @click="onDeleteTenant"
              >
                <i class="fa fa-trash"></i>
                {{ $t("apartment.deleteTenant") }}
              </button>
              <button
                v-if="has_perm('update_apartment') || GET_ACCOUNT_DATA.id == 1"
                type="button"
                class="btn btn-labeled btn-success pull-right"
                style="margin-right: 5px;"
                @click="onOpenMainTenant"
              >
                <span class="btn-label">
                  <i class="glyphicon glyphicon-edit"></i>
                </span>
                {{ $t(`apartment.edittenant`) }}
              </button>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <b>{{ $t("apartment.tenantInfo.tenantMembers") }}:</b> <br />
            <br />
            <div class="col-xs-12 table-responsive">
              <b-table
                :items="resident_items"
                :fields="resident_fields"
                class="mt-3"
                outlined
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #cell(actions)="row">
                  <div class="btn-group">
                    <button
                      class="btn btn-primary"
                      style="margin-left: 6px;"
                      @click="onOpenEditRelative(row)"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                    <button
                      class="btn btn-danger"
                      style="margin-left: 6px;"
                      @click="onOpenDeleteRelative(row)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Sửa Thông Tin Main Person -->
    <div class="modal fade" :ref="`modal-main-tenant`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("apartment.tenantInfo.title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15" v-if="tenant.id !== 0">
              <div class="col-md-3">
                {{ $t("apartment.tenantInfo.changeTenant") }}
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div
                    class="radio custom-control-inline"
                    v-for="(option, index) in radioOptions"
                    :key="index"
                  >
                    <label>
                      <input
                        type="radio"
                        :value="option.value"
                        checked
                        name="updateNewMain"
                        v-model="updateNewMain"
                        :disabled="!is_debt_free"
                      />
                      {{ option.text }}
                    </label>
                  </div>
                  <br />
                  <span class="label label-warning" v-if="!is_debt_free">{{
                    $t("customer.msg_current_debt")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.apartmentTenant") }}</div>
              <div style="margin-top:-16px;">
                <span v-if="updateNewMain || tenant.id === 0">
                  <lte-selectoptiontable
                    :item="itemCustomer"
                    @onchangeselect="onChangeSelect"
                  ></lte-selectoptiontable>
                </span>
                <span class="col-md-6" v-else>
                  <input
                    type="text"
                    class="form-control"
                    :value="main_person_full_name"
                    readonly
                  />
                </span>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              @click="onCancelMainPerson"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveMainTenant"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Modal Sửa Thông Tin Người Thân -->
    <div class="modal fade" :ref="`modal-apartment-tenant`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartment.tenantInfo.tenantMembers") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.customer") }}</div>
              <div class="col-md-6">
                <span class="form-control" style="height: fit-content">{{
                  `${tenant.resident.last_name} ${tenant.resident.first_name}`
                }}</span>
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.relative") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="available_customers"
                  v-model="selected_relative_person.resident.id"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">
                {{ $t("apartment.relationship_note") }}
              </div>
              <div class="col-md-6">
                <input
                  v-model="selected_relative_person.relationship_note"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.resident_status") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="residentStatusOptions"
                  v-model="selected_relative_person.resident_status"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveRelativeTenant"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Modal Confirm Delete Relative -->
    <div class="modal fade" :ref="`modal-relative-delete-${resident_type}`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t('apartment.tenantInfo.deleteTenantMember') }}</h4>
          </div>
          <div class="modal-body">{{ $t('apartment.tenantInfo.confirmDeleteTenantMember') }}</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="onDeleteRelative"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
//import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import constants from "@/lib/constantsData";
import i18n from "../../lang";
import utils from '@/lib/utils';
import SelectOptionTable from "@/components/SelectOptionTable.vue";
import LTEModal from "@/components/LTEModal.vue";
import Enum from "../../../enum/enum";

// Import EventBus.
//import { EventBus } from './event-bus.js';

export default {
  name: "MainContactDetails",
  props: {
    apartment_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    apartment_code: {
      type: String,
      default: () => {
        return null;
      }
    },
    resident_type: {
      type: String,
      default: () => {
        return "tenant";
      }
    },
    renterObjects: {
      type: Object,
      default: () => {
        return null;
      }
    },
    renterMembersArray: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      liability_search: {
        from_date: null,
        to_date: null,
        apartment_code: ""
      },
      tenant: {
        id: 0,
        resident: {
          id: 0,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        resident_movein: null,
        resident_moveout: null,
        start_efigure: 0,
        start_wfigure: 0,
        update_start_efigure: 0,
        update_start_wfigure: 0,
        resident_status: null,
        available_customers: [],
        period_selected: 0,
        periods_list_current: []
      },
      selected_relative_person: {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        relationship: null,
        resident_status: null,
        relationship_note: null
      },
      residentStatusOptions: constants.residentStatusOptions,
      dateOptions: {
        format: "DD/MM/YYYY"
      },
      customers: [],
      resident_items: [],
      resident_fields: [
        {
          key: "full_name",
          label: "apartment.fullname",
          sortable: true,
          class: "text-center"
        },
        {
          key: "phone",
          label: "apartment.phone",
          sortable: true,
          class: "text-center"
        },
        {
          key: "email",
          label: "apartment.email",
          sortable: true,
          class: "text-center"
        },
        {
          key: "country",
          label: "apartment.country",
          sortable: true,
          class: "text-center"
        },
        {
          key: "underAge",
          label: "customer.age",
          sortable: true,
          class: "text-center"
        },
        {
          key: "resident_status",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        // {
        //   key: "relationship",
        //   label: "apartment.relationship",
        //   sortable: true,
        //   class: "text-center"
        // },
        {
          key: "relationship_note",
          label: "common.note",
          sortable: true,
          class: "text-center"
        },
        { key: "actions", label: "common.action", class: "text-center" }
      ],
      radioOptions: [
        { text: "Đổi", value: true },
        { text: "Không", value: false }
      ],
      isExistMonthlyUsage: false,
      updateNewMain: false,
      itemCustomer: {
        data_list: [],
        itemType: 0,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-3",
        cssClassSm2: "col-sm-6",
        showAddNew: false
      },
      current_debt: 0,
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.btnYes",
          body: "customer.notiRemoveTenantApartment",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      isTenantApartment: false
    };
  },
  watch: {
    GET_CURRENT_USAGE_DATA: function() {},

    GET_RESIDENT_DATA: function() {
      // get main person & relatives of main person
      let tenant = "";
      let relatives = [];
      for (let i = 0, size = this.GET_RESIDENT_DATA.length; i < size; i++) {
        let resident = this.GET_RESIDENT_DATA[i];
        if (
          this.resident_type === "tenant" &&
          resident.isTenant == true &&
          resident.relationship_to === null
        ) {
          tenant = resident;
        } else if (
          this.resident_type === "tenant" &&
          resident.isTenant == false &&
          resident.isOwner == false
        ) {
          relatives.push(resident);
        }
      }
      // refresh main person details
      if (!tenant) {
        tenant = {
          id: 0,
          resident: {
            id: 0,
            first_name: "",
            last_name: "",
            email: "",
            username: "",
            phone: "",
            country_name: "",
            dob: null,
            identificationnumber: "",
            gender: 0
          },
          resident_movein: null,
          resident_moveout: null,
          start_efigure: 0,
          start_wfigure: 0,
          resident_status: null,
          is_approved: Enum.ApartmentResidentApprovalEnum.APPROVED
        };
      }
      this.getTenant(tenant);
      // refresh relatives
      this.getRelatives(relatives);

      // Show select for cycle
      let data = this.GET_CURRENT_USAGE_DATA;
      this.tenant.update_start_efigure = data.e_value;
      this.tenant.update_start_wfigure = data.w_value;
      let is_enable_current_cycle = data.is_enable_current_cycle;
      let is_enable_next_cycle = data.is_enable_next_cycle;
      let periods_list = [];
      if (is_enable_current_cycle) {
        let item = {
          value: data.period_current.type_period,
          text:
            "Chu kì hiện tại (" +
            utils.formatSqlDate(data.period_current.date_from, null, "DD/MM") +
            "-" +
            utils.formatSqlDate(data.period_current.date_to, null, "DD/MM") +
            ")",
          period_current: data.period_current
        };

        periods_list.push(item);
      }
      if (is_enable_next_cycle) {
        let item = {
          value: data.period_next.type_period,
          text:
            "Chu kì tiếp theo (" +
            utils.formatSqlDate(data.period_next.date_from, null, "DD/MM") +
            "-" +
            utils.formatSqlDate(data.period_next.date_to, null, "DD/MM") +
            ")",
          period_next: data.period_next
        };
        this.tenant.period_selected = 1;
        periods_list.push(item);
      }

      if (is_enable_current_cycle) {
        this.tenant.period_selected = 0;
      }

      this.tenant.periods_list_current = periods_list;
      // END --- Show select for cycle
    },
    apartment_id: function() {
      let apartment_id = this.apartment_id;
      if (parseInt(apartment_id) !== 0) {
        this.getResidents(apartment_id);
      }
    },
    apartment_code: function() {
      this.onSearch(); // this is liability serach
    },
    APARTMENT_MONTHLY_USAGE_DATA: function() {
      for (
        let i = 0, size = this.APARTMENT_MONTHLY_USAGE_DATA.length;
        i < size;
        i++
      ) {
        let monthlyUsage = utils.formatSqlDate(this.APARTMENT_MONTHLY_USAGE_DATA[i].date_to, null, "MM/YYYY");
        let monthNow = moment(new Date()).format("MM/YYYY");
        //Check disable if exist monthly usage > month now
        if (monthlyUsage < monthNow) {
          this.isExistMonthlyUsage = true;
          break;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_RESIDENT_DATA",
      "GET_SNACK_BAR",
      "APARTMENT_MONTHLY_USAGE_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CURRENT_USAGE_DATA"
    ]),
    day_of_birth: function() {
      return utils.formatSqlDate(this.tenant.resident.dob, null, this.dateOptions.format);
    },
    day_move_in: function() {
      return utils.formatSqlDate(this.tenant.resident_movein, null, this.dateOptions.format);
    },
    day_move_out: function() {
      return utils.formatSqlDate(this.tenant.resident_moveout, null, this.dateOptions.format);
    },
    available_customers: function() {
      let available_customers = [];
      for (let i = 0; i < this.customers.length; i++) {
        let customer = this.customers[i];
        let exist_ind = false;
        for (let j = 0; j < this.GET_RESIDENT_DATA.length; j++) {
          let resident = this.GET_RESIDENT_DATA[j];
          if (resident.resident.id === customer.value) {
            exist_ind = true;
          }
        }
        if (!exist_ind) {
          available_customers.push(customer);
        }
      }
      this.setAvailableCustomers(available_customers);
      return available_customers;
    },
    main_person_full_name: function() {
      if (utils.isEnglishLanguage(i18n.locale)) {
        return `${this.tenant.resident.first_name} ${this.tenant.resident.last_name}`;
      } else {
        return `${this.tenant.resident.last_name} ${this.tenant.resident.first_name}`;
      }
    },
    is_debt_free: function() {
      if (parseInt(this.current_debt) != 0) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions([
      "GET_RESIDENT_LIST",
      "GET_CUSTOMER_LIST",
      "ADD_RESIDENT",
      "UPDATE_RESIDENT",
      "GET_RESIDENT_DETAIL",
      "DELETE_RESIDENT",
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_MONTHLY_USAGE",
      "GET_CURRENT_USAGE"
    ]),
    ...mapActions("accountingHomeLiabilityModule", [
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL",
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    isNull: function(data) {
      return utils.isNull(data)
    },
    formatNumber: function(n) {
      if (n !== null || n !== 0) {
        return utils.formatNumber(n);
      }
      return 0;
    },
    // START: công nợ actions
    initializeLiabilityData() {
      this.liability_search.from_date = moment(new Date(), this.dateOptions.format).format("DD/MM/YYYY");
      this.liability_search.to_date = moment(new Date(), this.dateOptions.format).format("DD/MM/YYYY");
      this.liability_search.apartment_code = this.apartment_code;
    },
    onSearch() {
      this.initializeLiabilityData();
      // let from_date = utils.formatSqlDate(this.liability_search.from_date, this.dateOptions.format, "DD/MM/YYYY hh:mm:ss");
      // let to_date = utils.formatSqlDate(this.liability_search.to_date, this.dateOptions.format, "DD/MM/YYYY hh:mm:ss");

      if (utils.isNull(this.liability_search.apartment_code)) {
        return;
      }
      // const data = {
      //   from_date: from_date,
      //   to_date: to_date,
      //   apartment_code: this.liability_search.apartment_code
      // };
      // this.get_search_accounting_home_liability_list(data);
    },
    get_search_accounting_home_liability_list(data) {
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST(data)
        .then(
          function(res) {
            if (res.data.length > 0) {
              let debt = res.data[0].closing_trade_payable_max;
              this.current_debt = utils.makeRoundNumber(debt);
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    // END: công nợ actions
    getFullNameByLanguage(data) {
      if (data != null) {
        return utils.getFullName(data.first_name, data.last_name, i18n.locale);
      } else {
        return utils.getFullName(
          this.tenant.resident.first_name,
          this.tenant.resident.last_name,
          i18n.locale
        );
      }
    },
    relative_status_name: function(status_id) {
      for (let i = 0; i < this.residentStatusOptions.length; i++) {
        let status = this.residentStatusOptions[i];
        if (status.value === status_id) {
          return status.text;
        }
      }
      return status_id;
    },
    getRelationshipName: function(status_id) {
      return utils.getRelationshipName(status_id)
    },
    onOpenMainTenant() {
      // reset radio option
      this.updateNewMain = false;
      $(this.$refs[`modal-main-tenant`]).modal("show");
    },
    onOpenAddRelative() {
      $(this.$refs[`modal-apartment-tenant`]).modal("show");
      // reset data
      this.selected_relative_person = {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null
        },
        relationship: null,
        resident_status: null,
        relationship_note: null,
        is_approved: Enum.ApartmentResidentApprovalEnum.APPROVED
      };
    },
    onCancelMainPerson() {
      let apartment_id = this.apartment_id;
      this.getResidents(apartment_id);
    },
    onSaveMainTenant() {
      let main_person_id = this.tenant.id;
      let tenant_id = this.tenant.id;
      if (
        this.tenant.resident.id == null ||
        this.tenant.resident.id == undefined ||
        this.tenant.resident.id == 0
      ) {
        let data = {
          message: "No Main Person",
          styleType: "danger"
        };
        this.ON_SHOW_TOAST(data);
        return;
      }
      if (this.updateNewMain || this.tenant.id === 0) {
        // current date for move in when new or change
        this.tenant.resident_movein = moment(new Date()).format("YYYY-MM-DDThh:mm:ss");
      }
      let data = {
        isMainContact: true,
        isOwner: false,
        isTenant: true,
        resident_movein: utils.formatSqlDate(this.tenant.resident_movein, null, "YYYY-MM-DDThh:mm:ss"),
        resident_moveout: utils.formatSqlDate(this.tenant.resident_moveout, null, "YYYY-MM-DDThh:mm:ss"),
        start_efigure: this.tenant.update_start_efigure,
        start_wfigure: this.tenant.update_start_wfigure,
        // resident_status: this.tenant.residence_status,
        resident_status: 1,
        relationship: null,
        relationship_note: null,
        apartment: parseInt(this.apartment_id),
        resident: this.tenant.resident.id,
        relationship_to: null,
        period_selected: {
          period_selected: this.tenant.period_selected,
          period_data: this.tenant.periods_list_current.filter(
            item => item.value == this.tenant.period_selected
          )[0]
        },
        is_approved: Enum.ApartmentResidentApprovalEnum.APPROVED
      };

      if (utils.isNull(main_person_id) && utils.isNull(main_person_id)) {
        this.addResident({ data: data });
      } else {
        this.updateResident({
          id: main_person_id === 0 ? tenant_id : main_person_id,
          data: data
        });
      }
      $(this.$refs[`modal-main-tenant`]).modal("hide");
    },
    onSaveRelativeTenant() {
      let selected_relative_id = this.selected_relative_person.id;
      if (this.tenant.resident.id == null) {
        let data = {
          message: "No Main Person",
          styleType: "danger"
        };
        this.ON_SHOW_TOAST(data);
        return;
      }
      let data = {
        isMainContact: false,
        isOwner: false,
        isTenant: false,
        resident_movein: null,
        resident_moveout: null,
        start_efigure: null,
        start_wfigure: null,
        resident_status: this.selected_relative_person.resident_status,
        relationship: this.selected_relative_person.relationship,
        relationship_note: this.selected_relative_person.relationship_note,
        apartment: parseInt(this.apartment_id),
        resident: this.selected_relative_person.resident.id,
        relationship_to: this.tenant.resident.id,
        is_approved: this.selected_relative_person.is_approved
      };
      if (utils.isEmptyString(data.resident)) {
        this.ON_SHOW_TOAST({
          message: this.$t("apartment.relative"),
          styleType: "danger"
        });
      } else if (selected_relative_id === 0) {
        this.addResident({ data: data });
      } else {
        this.updateResident({ id: selected_relative_id, data: data });
      }
    },
    addResident(payload) {
      this.ADD_RESIDENT({ data: payload.data })
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            let apartment_id = this.apartment_id;
            this.getResidents(apartment_id);
            this.$emit("mainperson-save", {});
            $(this.$refs[`modal-apartment-tenant`]).modal("hide");
          }.bind(this)
        )
        .catch(
          function(error) {
            //this.ERROR_TOAST();
            let mess = error.response.data.msg !== undefined
              ? error.response.data.msg : error.response.data.message
            let data = {
              message: mess,
              styleType: "danger"
            };
            this.ON_SHOW_TOAST(data);
            this.getResidents(apartment_id);
          }.bind(this)
        );
    },
    updateResident(payload) {
      this.UPDATE_RESIDENT({ id: payload.id, data: payload.data })
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            let apartment_id = this.apartment_id;
            this.getResidents(apartment_id);
            this.$emit("mainperson-save", {});
            $(this.$refs[`modal-apartment-tenant`]).modal("hide");
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.msg !== undefined
              ? error.response.data.msg : error.response.data.message
            let data = {
              message: mess,
              styleType: "danger"
            };
            this.ON_SHOW_TOAST(data);
            let apartment_id = this.apartment_id;
            this.getResidents(apartment_id);
          }.bind(this)
        );
    },
    getResidents(apartment_id) {
      const apartmentdata = {
        params: {
          apartment: apartment_id
        }
      };
      this.GET_RESIDENT_LIST(apartmentdata).then(function() {}.bind(this));
    },
    //Get tenant
    getTenant(tenant) {
      this.tenant = {};
      this.tenant = {
        id: tenant.id,
        resident: {
          id: tenant.resident && tenant.resident.id,
          first_name: tenant.resident && tenant.resident.first_name,
          last_name: tenant.resident && tenant.resident.last_name,
          email: tenant.resident && tenant.resident.email,
          username: tenant.resident && tenant.resident.username,
          phone: tenant.resident && tenant.resident.phone,
          gender:
            tenant.resident && tenant.resident.gender !== 0
              ? tenant.resident && tenant.resident.gender == 1
                ? "customer.gender_type[0]"
                : tenant.resident && tenant.resident.gender == 2
                ? "customer.gender_type[1]"
                : "customer.gender_type[2]"
              : "",
          country_name: tenant.resident && tenant.resident.country_name,
          dob: tenant.resident && tenant.resident.dob,
          identificationnumber:
            tenant.resident && tenant.resident.identificationnumber
        },
        resident_movein: tenant && tenant.resident_movein,
        resident_moveout: tenant.resident_moveout,
        start_efigure: tenant.resident && tenant.start_efigure,
        start_wfigure: tenant.resident && tenant.start_wfigure,
        resident_status: tenant.resident && tenant.resident_status
      };
      this.isTenantApartment = tenant.id === 0 ? false : true
      this.$emit("tenant", { tenant: this.tenant.resident });
    },
    getRelatives(relatives) {
      let resident_items = [];
      relatives.forEach(relative => {
        // check if relatives of main person
        if (
          relative != undefined &&
          this.tenant != undefined &&
          relative.relationship_to != undefined &&
          this.tenant.resident != undefined &&
          relative.relationship_to.id !== this.tenant.resident.id
        ) {
          return;
        }
        if (!relative.isOwner || relative.isOwner === "No") {
          let full_name = `${relative.resident.last_name} ${relative.resident.first_name}`;
          let phone = relative.resident.phone;
          let email = relative.resident.email;
          let country_name = relative.resident.country_name;
          let age = relative.resident.dob ? moment().diff(relative.resident.dob, "years") : 0;
          let underAge = age;
          let resident_status = this.relative_status_name(relative.resident_status);
          let relationship = this.getRelationshipName(relative.relationship);
          let relationship_note = relative.relationship_note;
          let item = {
            id: relative.id,
            full_name: full_name,
            phone: phone,
            email: email,
            country_name: country_name,
            underAge: underAge,
            relationship: relationship,
            resident_status: resident_status,
            relationship_note: relationship_note,
            is_approved: relative.is_approved
          };
          resident_items.push(item);
        }
      });
      this.resident_items = resident_items;
    },
    onOpenEditRelative(row) {
      $(this.$refs[`modal-apartment-tenant`]).modal("show");
      this.GET_RESIDENT_DETAIL({ id: row.item.id }).then(
        function(res) {
          let resident_detail = res.data;
          this.selected_relative_person = {
            id: resident_detail.id,
            resident: {
              id: resident_detail.resident.id,
              first_name: resident_detail.resident.first_name,
              last_name: resident_detail.resident.last_name,
              email: resident_detail.resident.email,
              username: resident_detail.resident.username,
              phone: resident_detail.resident.phone,
              country_name: resident_detail.resident.country_name,
              dob: resident_detail.resident.dob
            },
            relationship: resident_detail.relationship,
            resident_status: resident_detail.resident_status,
            relationship_note: resident_detail.relationship_note
          };
        }.bind(this)
      );
    },
    onOpenDeleteRelative(row) {
      $(this.$refs[`modal-relative-delete-${this.resident_type}`]).modal(
        "show"
      );
      this.deleteRelativeId = row.item.id;
    },
    onDeleteRelative() {
      this.DELETE_RESIDENT({ id: this.deleteRelativeId }).then(
        function() {
          let apartment_id = this.apartment_id;
          this.getResidents(apartment_id);
          $(this.$refs[`modal-relative-delete-${this.resident_type}`]).modal(
            "hide"
          );
        }.bind(this)
      );
    },
    onChangeSelect: function(type_value) {
      this.tenant.resident.id = type_value;
      this.$emit("customer", { customer: this.tenant.resident });
    },
    setAvailableCustomers: function(data) {
      if (data !== undefined) {
        this.itemCustomer.data_list = data;
      }
    },
    // 
    onDeleteTenant: function() {
      this.isModalVisible = true
    },
    closeModal: function() {
      this.isModalVisible = false
    },
    onConfirm: function() {
      this.isLoading = true;
      this.DELETE_RESIDENT({ id: this.tenant.id }).then(
        function() {
          this.setTenantDefault();
          this.closeModal()
          let apartment_id = this.apartment_id;
          this.getResidents(apartment_id);
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
          function(error) {
            let data = {
              message: error.response.data.msg,
              styleType: "danger"
            };
            this.ON_SHOW_TOAST(data);
            this.isLoading = false;
          }.bind(this)
        );
    },
    setTenantDefault: function() {
      this.tenant = {
        id: 0,
        resident: {
          id: 0,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        resident_movein: null,
        resident_moveout: null,
        start_efigure: 0,
        start_wfigure: 0,
        update_start_efigure: 0,
        update_start_wfigure: 0,
        resident_status: null,
        available_customers: [],
        period_selected: 0,
        periods_list_current: []
      }
    }
  },
  mounted() {
    this.onSearch();
    this.GET_CUSTOMER_LIST().then(
      function(res) {
        let customerList = res.data;
        let customers = [{ value: null, text: "---" }];
        customerList.forEach(data => {
          let full_name = this.getFullNameByLanguage(data);
          let item = {
            value: data.id,
            text: full_name,
            email: data.email,
            dob: data.profile ? utils.formatSqlDate(data.profile.dob, null, "DD/MM/YYYY") : null,
            phone: data.profile ? data.profile.phone : null,
            passport: data.profile ? data.profile.passport : null
          };
          customers.push(item);
        });
        this.customers = customers;
        let apartment_id = this.apartment_id;
        if (parseInt(apartment_id) !== 0) {
          this.getResidents(apartment_id);
        }
      }.bind(this)
    );
    //Get apartment monthly usage
    const filter = {
      params: {
        page: 1,
        apartmentid: this.$route.params.id
      }
    };
    this.GET_APARTMENT_MONTHLY_USAGE(filter).then(function(res) {}.bind(this));

    //Get period current
    const filter_period_current = {
      params: {
        apartment_id: this.$route.params.id,
        current_local_pc_time: moment(new Date(), "DD-MM-YYYY").format("DD/MM/YYYY")
      }
    };
    this.GET_CURRENT_USAGE(filter_period_current).then(
      function(res) {}.bind(this)
    );
  },
  components: {
    //"date-picker": datePicker,
    "lte-core-alert": LTECoreAlert,
    "lte-selectoptiontable": SelectOptionTable,
    "lte-modal": LTEModal
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-down-15 {
  margin-bottom: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.label-red {
  background-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentTenant.vue